import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { trackTrialCTAClick, trackTrialStatusCTAClick } from '../../topPanels/utils';
import { getUserData } from '../../selectors/user';
import { getTrialDaysLeft } from '../utils';
import { HEADERS } from '../consts';
import css from '../style.css';

const HOUR_MS = 60 * 60 * 1000;

function TrialChip() {
    const userData = useSelector(getUserData) || {};
    const isTrial = !!userData.trial;
    const [clicked, setClicked] = useState(false);
    const [, setHourTick] = useState(0);

    useEffect(() => {
        if (!isTrial) return undefined;
        const timer = setInterval(() => setHourTick(tick => tick + 1), HOUR_MS);
        return () => clearInterval(timer);
    }, [isTrial]);

    if (!isTrial) {
        return null;
    }

    const { realDaysLeft, daysLeft } = getTrialDaysLeft(userData.trial);
    const daysLeftKey = daysLeft > 1 || daysLeft === 0 ? 'TRIAL_DAYS_LEFT' : 'TRIAL_DAY_LEFT';

    const onUpgradeClick = () => {
        setClicked(true);
        trackTrialCTAClick(userData.email, userData.first_name, userData.last_name, userData.company);
        trackTrialStatusCTAClick(realDaysLeft, 'header');
    };

    if (clicked) {
        return (
            <div className={classNames(css.planChip, css.hideBelowXl)}>
                <Translate id="STATIC.PAGES.TRIAL_STATUS_PANEL.PANEL_UPGRADED_TEXT" />
            </div>
        );
    }

    return (
        <div className={classNames(css.planChip, css.hideBelowXl)}>
            <span
                className={classNames({
                    [css.planCountWarning]: daysLeft <= 15 && daysLeft > 7,
                    [css.planCountAlert]: daysLeft <= 7,
                })}
            >
                {daysLeft}
            </span>
            <Translate id={`${HEADERS}.${daysLeftKey}`} />
            <button type="button" className={css.menuToggle} onClick={onUpgradeClick}>
                <Translate id={`${HEADERS}.UPGRADE_USER_PLAN_BUTTON`} />
            </button>
        </div>
    );
}

export default TrialChip;
